<template>
  <b-row>
    <!-- ทดสอบ -->
    <!-- <b-card>Mode Group : {{modeGrp}}</b-card>
    <b-card>IsProcessAvailable : {{complaintGroupIsProcessAvailable}}</b-card>
    <b-card>complaintGroupId : {{complaintGroupId}}</b-card>
    <b-card>qlId : {{qlId}}</b-card>
    <b-card>qlStatus : {{qlStatus}}</b-card>
    <b-card>qlRemark : {{qlRemark}}</b-card> -->

    <!-- แสดงหัวข้อเลขร้องทุกข์แบบกลุ่ม -->
    <b-card class="container text-center">
      <h4>เลขร้องทุกข์แบบกลุ่ม : {{ this.complaintGroupCode }}</h4>
      <b
        :style="{ color: textColor }"
        v-if="complaintGroupIsProcessAvailable === false"
      >
        หมายเหตุ : กำลังประมวลผล
      </b>
    </b-card>

    <b-card class="w-100">
      <!-- ไม่ได้ใช้งาน -->
      <!-- <div class="accordion" role="tablist">
        <b-card
          v-for="(item, key) in complaintGroupDetails"
          :key="key"
          no-body
          class="mb-1"
        >
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
              @click="onComplaintHeaderClick(item.complaintId)"
              block
              v-b-toggle="'accordion-' + key + 1"
              variant="outline-primary"
              >{{ item.complaintCode }}</b-button
            >
          </b-card-header>
          <b-collapse
            :id="'accordion-' + key + 1"
            :visible="key === 0 ? true : false"
            role="tabpanel"
          >
            <b-card-body>
              <ComplaintGroupDetail
                :routeName="routeName"
                :listRouteName="listRouteName"
                :complaintGroupDetail="item"
                :isLoad="item.isLoad"
              ></ComplaintGroupDetail>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div> -->

      <!-- ทดสอบ -->
      <!-- <span>Mode Search : {{ this.modeGrp }}</span><br>
      <span>complaintGroupId : {{ this.complaintGroupId }}</span></span><br>
      <span>complaintGroupIssue : {{ this.complaintGroupIssue }}</span></span><br>
      <span>complaintGroupCode : {{ this.complaintGroupCode }}</span></span><br> -->

      <b-tabs>
        <!-- 1. เรื่องร้องทุกข์ -->
        <b-tab id="tab-left-complaint" title="เรื่องร้องทุกข์">
          <div class="accordion" role="tablist">
            <b-card
              v-for="(item, key) in complaintGroupDetails"
              :key="key"
              no-body
              class="mb-1"
            >
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button
                  @click="onComplaintHeaderClick(item.complaintId)"
                  block
                  v-b-toggle="'accordion-' + key + 1"
                  variant="outline-primary"
                  >{{ item.complaintCode }}</b-button
                >
              </b-card-header>
              <b-collapse
                :id="'accordion-' + key + 1"
                :visible="key === 0 ? true : false"
                role="tabpanel"
              >
                <b-card-body>
                  <ComplaintGroupDetail
                    :routeName="routeName"
                    :listRouteName="listRouteName"
                    :complaintGroupDetail="item"
                    :isLoad="item.isLoad"
                  ></ComplaintGroupDetail>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>
        </b-tab>
        <!-- 2. จัดการเรื่องร้องทุกข์ -->
        <b-tab id="tab-left-manage" title="จัดการเรื่องร้องทุกข์">
          <b-col class="container text-right">
            <b-button
              variant="info"
              class="mb-2 mr-sm-2"
              @click="onBtnAddComplaintGroupClicked"
              :enabled="complaintGroupIsProcessAvailable"
            >
              <feather-icon icon="PlusIcon" class="mr-25" />
              <span>เพิ่มเรื่องร้องทุกข์เข้ากลุ่ม</span>
            </b-button>
          </b-col>

          <b-overlay :show="showOverlay" rounded="sm">
            <b-card>
              <b-col>
                <b-form-group label="รายละเอียดการจัดกลุ่มเรื่องร้องทุกข์">
                  <b-form-input
                    v-model="this.complaintGroupIssue"
                    required
                    :enabled="complaintGroupIsProcessAvailable"
                    placeholder="กรุณากรอกรายละเอียดการจัดกลุ่มเรื่องร้องทุกข์"
                  />
                </b-form-group>
              </b-col>

              <b-col>
                <SearchFilter
                  ref="searchFilter"
                  :mode="modeGrp"
                  :autoSearch="true"
                  @handleSubmit="searchFilterSubmit"
                />
              </b-col>

              <b-col>
                <CommonTable
                  ref="tableCommon"
                  :routeName="$route.name"
                  :tableHeader="tableHeader"
                  :searchMode="modeGrp"
                  :isOption="isOption"
                  :isGroup="true"
                  @handle-select="onSelectChange"
                  @handleOverlay="setOverlay"
                />
                <!-- <footer
                  id="modal-transfer___BV_modal_footer_"
                  class="modal-footer d-flex justify-content-between"
                >
                  <button
                    type="button"
                    class="btn btn-warning"
                    block
                    @click="onSubmitMovGroup"
                  >
                    ลบเรื่องร้องทุกข์ออกจากกลุ่ม
                  </button>
                </footer> -->
              </b-col>
              <footer
                id="modal-transfer___BV_modal_footer_"
                class="container text-right"
              >
                <button
                  type="button"
                  class="btn btn-warning"
                  block
                  @click="onSubmitMovGroup"
                  :enabled="complaintGroupIsProcessAvailable"
                >
                  <feather-icon icon="delete" class="mr-25" />
                  ลบเรื่องร้องทุกข์ออกจากกลุ่ม
                </button>
              </footer>
            </b-card>
          </b-overlay>
        </b-tab>
        <!-- 3. สถานะการดำเนินการ -->
        <b-tab id="tab-left-status" title="สถานะการดำเนินการ">
          <b-card>
            <!-- สถานะคิว -->
            <b-col>
              <b-form-group label="สถานะคิว (รายละเอียดหลัก)">
                <b-form-input v-model="qlStatus" :disabled="true" />
              </b-form-group>
            </b-col>

            <!-- หมายเหตุคิว -->
            <b-col>
              <b-form-group label="หมายเหตุคิว (รายละเอียดหลัก)">
                <b-form-input v-model="qlRemark" :disabled="true" />
              </b-form-group>
            </b-col>

            <b-overlay :show="showOverlay" rounded="sm">
              <b-card>
                <!-- searchFilterTabStatus -->
                <b-col>
                  <SearchFilterTabStatus
                    ref="searchFilterTabStatus"
                    @handleSubmitTabStatus="searchFilterSubmitTabStatus"
                  />
                </b-col>

                <!-- CommonTableTabStatus -->
                <b-col>
                  <CommonTableTabStatus
                    ref="tableCommonTabStatus"
                    :qlId="qlId"
                    @handleOverlay="setOverlay"
                  />
                </b-col>
              </b-card>
            </b-overlay>
          </b-card>
        </b-tab>
      </b-tabs>
    </b-card>

    <ModalComplaintGroup
      ref="ModalComplaintGroup"
      :modeGrp="modeGrp"
      :isInGroup="false"
      :complaintGroupId="complaintGroupId"
      :complaintGroupCode="complaintGroupCode"
      :complaintGroupIssue="this.complaintGroupIssue"
    />
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardText,
  BCardHeader,
  BCardBody,
  BButton,
  BListGroup,
  BListGroupItem,
  BCollapse,
  VBToggle,
  BTab,
  BTabs,
  BFormGroup,
  BFormInput,
  BOverlay,
} from "bootstrap-vue";

import appsetting from "@/store/app-settings/index.js";

import ComplaintGroupDetail from "./ComplaintGroupDetail";

import ModalComplaintGroup from "@/views/Complaint/components/ComplaintGroup/components/ModalComplaintGroup.vue";
import CommonTable from "@/views/Complaint/components/vueGoodTable/commonTable.vue";
import CommonTableHeader from "@/views/Complaint/components/vueGoodTable/commonTableHeader.js";
import SearchFilter from "@/views/Complaint/components/vueGoodTable/SearchFilter.vue";

import * as complaintGroupStore from "@/store/api/complaint/complaintGroup.js";
import * as userData from "@/auth/localStorageUtils.js";

// for status
import SearchFilterTabStatus from "@/views/Complaint/components/ComplaintGroup/components/SearchFilter.vue";
import CommonTableTabStatus from "@/views/Complaint/components/ComplaintGroup/components/commonTable.vue";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardText,
    BCardHeader,
    BCardBody,
    BButton,
    BListGroup,
    BListGroupItem,
    BCollapse,
    VBToggle,
    ComplaintGroupDetail,

    BTab,
    BTabs,
    BFormGroup,
    BFormInput,
    BOverlay,
    ModalComplaintGroup,
    CommonTable,
    CommonTableTabStatus,
    SearchFilter,
    SearchFilterTabStatus,
  },
  directives: {
    "b-toggle": VBToggle,
  },
  props: {
    routeName: String,
    listRouteName: String,
    complaintGroupDetails: [],

    complaintGroupId: null,
    complaintGroupIssue: null,
    complaintGroupCode: null,
    complaintGroupIsProcessAvailable: false,
    modeGrp: "",
  },
  data() {
    return {
      showOverlay: false,
      textNote: "",
      isOption: true,
      isReadOnly: false,
      selects: [],
      tableHeader: CommonTableHeader,
      departmentReq: "",
      userActiveReq: "",
      textColor: "red",
      qlStatus: "",
      qlRemark: "",
      qlId: "",
    };
  },
  mounted() {},
  created() {
    // console.log("test-complaintGroupIssue", this.complaintGroupIssue);
    // this.setNote(); // ใช้สำหรับเปลี่ยนข้อความรายละเอียดจัดกลุ่มร้องทุกข์
    this.getMessageQue();
  },
  methods: {
    onComplaintHeaderClick(complaintId) {
      //console.log("onComplaintHeaderClick", complaintId);
      this.$emit("handleOnComplaintHeaderClick", complaintId);
    },
    onBtnAddComplaintGroupClicked() {
      this.$refs.ModalComplaintGroup.$refs["modal-add-complaint-group"].show();
    },
    setOverlay(isShow) {
      this.showOverlay = isShow;
    },
    searchFilterSubmit(params) {
      const _this = this;

      // เอาออกเนื่องจาก Copy มาจาก ModalComplaintGroup [ไม่ใช้งาน แต่เพื่อ]
      if (this.modeGrp === "Screening") {
        ///params.departmentId = appsetting.complaintdepartmentId.screening;
        /// เปลี่ยนให้ใส่ userData.departmentId() แทนแล้วสำหรับคัดกรอง
        params.departmentId = userData.departmentId();
      } else if (this.modeGrp === "Officer") {
        params.departmentId = userData.departmentId();
      } else if (this.modeGrp === "LawOfficer") {
        params.departmentId = userData.departmentId();
      }

      params.tabName = "All";
      params.isInGroup = true; // แสดงเฉพาะเรื่องร้องทุกข์ที่อยู่ในกลุ่ม
      params.userActive = userData.userId();
      params.refComplaintGroupId = this.complaintGroupId;

      console.log("แสดงมาจาก ComplaintGroupDetailsList", params);
      this.$refs.tableCommon.onSearchSubmit(params);
    },
    searchFilterSubmitTabStatus(params) {
      const _this = this;

      console.log("searchFilterSubmitTabStatus", params);
      console.log("searchFilterSubmitTabStatus", _this.qlId);

      params.qlId = _this.qlId;

      _this.$refs.tableCommonTabStatus.onSearchSubmit(params);
    },
    onSelectChange(selects) {
      console.log("onSelectChange", selects);
      this.selects = selects;
    },
    onSubmitMovGroup() {
      const _this = this;
      console.log("this.$refs", _this.$refs);
      console.log("this.selects", _this.selects);
      console.log("onSubmitMovGroup", appsetting.complaintdepartmentId);

      if (this.selects.length < 1) {
        this.$bvToast.toast(
          "กรุณาเลือกเรื่องร้องทุกข์ที่ต้องการนำออกอย่างน้อย 1 รายการ",
          {
            title: `เลือกเรื่องร้องทุกข์นำออกจากกลุ่ม`,
            variant: "danger",
            solid: false,
          }
        );
        console.log("Validate[False] : เลือกเรื่องร้องทุกข์นำออกจากกลุ่ม");
        return;
      }

      // เอาเฉพาะ complaint id
      const complaintIdsMov = this.selects.map((value) => {
        return value.complaintId;
      });
      console.log("complaintIdsMov", complaintIdsMov);

      // พารามิเตอร์สำหรับเอาเรื่องร้องทุกข์ออก
      const movParams = {
        complaintGroupId: this.complaintGroupId,
        complaintIds: complaintIdsMov,
        userActive: userData.userId(),
      };
      console.log("movParams", movParams);

      complaintGroupStore
        .movComplaintGroup(movParams)
        .then(function(response) {
          // handle success

          console.log("movComplaintGroup", response);

          if (response.data.success === true) {
            _this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
              title: `ระบบได้บันทึกการแก้ไขของท่านแล้ว`,
              variant: "success",
              solid: false,
            });

            // เรียก searchFilter อีกครั้ง เนื่องจากหลังปรับ API จะไม่เอาตัวที่จัดกลุ่มไปแล้วขึ้นมาแสดง
            _this.$refs.searchFilter.onSearchBtnClicked();
          } else {
            _this.$bvToast.toast(response.data.message, {
              title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
              variant: "danger",
              solid: false,
            });
          }
        })
        .catch(function(error) {
          _this.$bvToast.toast(error, {
            title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
            variant: "danger",
            solid: false,
          });
        })
        .then(function() {
          // always executed
          // console.log("GET");
          _this.$emit("handleOverlay", false);
        });
    },
    selectOnInput() {
      this.$forceUpdate();
    },
    setNote() {
      console.log("แสดง props", this.props);
      console.log("แสดง complaintGroupId", this.complaintGroupId);
      console.log("แสดง complaintGroupIssue", this.complaintGroupIssue);
      console.log("แสดง complaintGroupCode", this.complaintGroupCode);
      console.log("แสดง textNote", this.textNote);

      if (
        this.complaintGroupIssue === null ||
        this.complaintGroupIssue === "" ||
        this.complaintGroupIssue === undefined
      ) {
        this.textNote = "";
        console.log("complaintGroupIssue", true);
      } else {
        this.textNote = this.complaintGroupIssue;
        console.log("complaintGroupIssue", false);
      }
      console.log("แสดง textNote หลังเปลี่ยนแปลง", this.textNote);
    },
    getMessageQue() {
      const _this = this;

      console.log("_this.$refs", _this.$refs);

      complaintGroupStore
        .getLastedByComplaintGroupId(this.complaintGroupId)
        .then(function(response) {
          console.log("getLastedByComplaintGroupId", response);

          _this.qlStatus = response.data.data.qlStatus;
          _this.qlRemark =
            response.data.data.qlRemark !== null &&
            response.data.data.qlRemark !== undefined &&
            response.data.data.qlRemark !== ""
              ? response.data.data.qlRemark
              : "ไม่ระบุ";
          _this.qlId = response.data.data.qlId;

          // trigger สำหรับ auto searchFilerTabStatus
          _this.$refs.searchFilterTabStatus.onSearchBtnClicked();
        })
        .catch(function(error) {
          console.log("error", error);
        })
        .then(function() {
          _this.$emit("handleOverlay", false);
        });
    },
    getStatusDropdown() {
      const _this = this;
    },
  },
};
</script>

<style></style>
